import React from 'react'
import logo from '../../assets/img/LogotipoLanding.png'

export const Home = () => {
  return (
    <div className='flex w-full h-full content-center items-center justify-center '>
      <img className=" bg-center opacity-20 object-contain  w-full content-end max-w-screen-sm" src={logo} alt="Logo"></img>
    </div>
  )
}